<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="bx bx-transfer me-1 text-primary"></i> Transactions
                                </h5>
                            </div>
                            <div class="col">
                                <div ngbDropdown autoClose="manual" class="d-inline-block" #dropdown="ngbDropdown">
                                    <button type="button" class="btn btn-outline-secondary" id="dropdownForm1"
                                        ngbDropdownToggle>
                                        <i class="bx bx-filter"></i> Filter
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="dropdownForm1">
                                        <div class="p-3">
                                            <div class="mb-2">
                                                <label><i class="bx bx-filter mr-1"></i>Date Filter</label>
                                                <ng-select class="ng-filter" [clearable]="false" [searchable]="false"
                                                    [(ngModel)]="selectedFilter">
                                                    <ng-option *ngFor="let f of filters" [value]="f">{{ f }}</ng-option>
                                                </ng-select>
                                            </div>

                                            <ng-container *ngIf="selectedFilter === 'Custom'">
                                                <div class="mb-2">
                                                    <label><i class="bx bx-calendar mr-1"></i>From Date</label>
                                                    <input type="date" [(ngModel)]="fromDate" class="form-control">
                                                </div>
                                                <div class="mb-2">
                                                    <label><i class="bx bx-calendar mr-1"></i>To Date</label>
                                                    <input type="date" [(ngModel)]="toDate" class="form-control">
                                                </div>
                                            </ng-container>

                                            <button type="button"
                                                (click)="filterAndFetchTransation(selectedFilter, dropdown)"
                                                class="btn btn-secondary w-100">
                                                Search
                                            </button>
                                        </div>
                                        <div class="dropdown-divider"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-auto ms-auto">
                                <button type="button" class="btn btn-secondary" (click)="upsertTransaction()"
                                    [ngClass]="{'not-allowed': !privilege.canEdit}"
                                    [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.transaction.edit' : ''">
                                    <i class="bx bx-plus"></i> Apply Transaction
                                </button>
                            </div>
                        </div>

                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="200">Date</th>
                                    <th scope="col" width="300">Ref Id</th>
                                    <th scope="col" width="300">Particular</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let transaction of tableData.content; let i = index">
                                    <td>{{ i + 1 }}.</td>
                                    <td>{{ transaction.date | date:'MMM dd, yyyy' }}</td>
                                    <td>{{ transaction.refId }}</td>
                                    <td>{{ transaction.particular || 'N/A' }}</td>
                                    <td class="actions">
                                        <i class="bx bx-edit alert-primary"
                                            [ngClass]="{
                                                'no-event': transaction?.isDeleteInProgress,
                                                'not-allowed': !privilege.canEdit
                                            }"
                                            [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.transaction.edit' : 'Update Transaction'"
                                            (click)="upsertTransaction(transaction)">
                                        </i>
                                        <i *ngIf="!transaction?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                                            [ngClass]="{'not-allowed': !privilege.canDelete}"
                                            [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): setup.transaction.delete' : 'Delete Transaction'"
                                            (click)="deleteTransaction(transaction, i)">
                                        </i>
                                        <div *ngIf="transaction?.isDeleteInProgress" role="status"
                                            class="spinner-border spinner-border-sm text-danger">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="9">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="tableData.content && tableData.content.length < 1; else noSearchResults">
                                            <td colspan="9">No transactions were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="9"
                                                *ngIf="searchKeyword && (tableData.content | search : 'title' : searchKeyword).length == 0">
                                                No transactiona were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row justify-content-between align-items-center pt-3">
                            <div class="col-lg-auto">
                              <div class="pagination-entries" id="tickets-table_length">
                                <label class="d-flex align-items-center m-0">
                                  <span>Items per page</span>
                                  <select name="tickets-table_length" aria-controls="tickets-table" [(ngModel)]="tableData.size"
                                    (change)="loadTableData(null)"
                                    class="custom-select custom-select-sm form-control form-control-sm mx-2">
                                    <option *ngFor="let page of pageSizes" [value]="page">{{page}}</option>
                                  </select>
                                </label>
                              </div>
                            </div>
                            <div *ngIf="tableData?.content?.length > 0" class="col-lg-auto">
                              <ngb-pagination [collectionSize]="tableData.totalElements" [(page)]="tableData.number"
                                [pageSize]="tableData.size" (pageChange)="onPageChange($event)">
                              </ngb-pagination>
                            </div>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>